import {
  Button,
  Checkbox,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Portal,
} from '@chakra-ui/react';
import { ReactSelectOption } from '@texas/types';
import { useTranslation } from 'react-i18next';
import { Icons } from '../shared/Icons';

interface SupplierBranchFilterProps {
  options: ReactSelectOption[];
  selectedBranchIds?: number[];
  onChange: (branchIds?: number[]) => void;
}

export function SupplierBranchFilter({
  options,
  selectedBranchIds = [],
  onChange,
}: SupplierBranchFilterProps) {
  const { t } = useTranslation();
  const selectedCount = selectedBranchIds.length;

  const toggleBranch = (branchId: number) => {
    const branchIds = selectedBranchIds.includes(branchId)
      ? selectedBranchIds.filter((id) => id !== branchId)
      : [...selectedBranchIds, branchId];

    onChange(branchIds.length > 0 ? branchIds : undefined);
  };

  return (
    <Menu closeOnSelect={false} isLazy={true}>
      <MenuButton
        as={Button}
        h="38px"
        minW="150px"
        rightIcon={<Icons.ChevronDown boxSize={4} />}
        size="sm"
        variant="entityDirectoryFilter"
      >
        {t('general.branches')}: {selectedCount || t('filter.all')}
      </MenuButton>
      <Portal>
        <MenuList maxH="320px" minW="240px" overflowY="auto" zIndex={20}>
          <MenuItem
            fontWeight={selectedCount === 0 ? 'semibold' : 'normal'}
            onClick={() => onChange(undefined)}
          >
            {t('filter.allBranches')}
          </MenuItem>
          <MenuDivider />
          {options.map((option) => {
            const branchId = option.value as number;

            return (
              <MenuItem key={branchId} onClick={() => toggleBranch(branchId)}>
                <Checkbox
                  isChecked={selectedBranchIds.includes(branchId)}
                  mr={2}
                  pointerEvents="none"
                />
                {option.label}
              </MenuItem>
            );
          })}
        </MenuList>
      </Portal>
    </Menu>
  );
}
